import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { VendorTsService } from '../../../../service/vendor/vendor.ts.service';

@Component({
  selector: 'app-vendor-black-list',
  templateUrl: './vendor-black-list.component.html',
  styleUrl: './vendor-black-list.component.scss'
})
export class VendorBlackListComponent implements OnInit {

  black_list_remark:string=''
  is_black_list:any
  is_legal_case:any
  vendor:string=''
  vendorStatus = "APPROVED"
  vendor_list: any[] = [];

  constructor(
    public messageService: MessageService,
    private vendorService: VendorTsService,
  ) { }

  ngOnInit(): void {
    this.getVendorList()
  }
  getVendorList() {
    this.vendorService.getVendorMList()
      .then(result => {
        result.message.forEach((data:any) => {
          if (data.is_black_list != "YES" && data.is_legal_case != "YES") {
            this.vendor_list.push(data)
          }
        });
      }).catch((error) => {
        console.log(error);
      });
  }

  isFormValid(): boolean {
      return this.vendor !== '' && this.is_black_list !== '' || this.is_legal_case !== '';
  }

  onSubmit(){
    if (this.is_black_list == true) {
      this.is_black_list = "YES"
    }else{
      this.is_black_list = "NO"
    }
    if (this.is_legal_case == true) {
      this.is_legal_case = "YES"
    }else{
      this.is_legal_case = "NO"
    }
    const blackListData = {
      black_list_remark: this.black_list_remark,
      is_black_list: this.is_black_list,
      is_legal_case: this.is_legal_case,
      vendor: this.vendor
    };
    this.vendorService.createBalckListVendor(blackListData).then((res)=>{
      if (res.message.status === "Success") {
        this.messageService.add({ severity: "success", summary: 'Success', detail: res.message.message });
        this.black_list_remark=''
        this.is_black_list=''
        this.is_legal_case=''
        this.vendor=''
        this.vendor_list=[]
        this.getVendorList()
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: res.message.message });
      }
    }).catch((error)=>{
      console.log(error)
    })
  }
}
